var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h6',{staticStyle:{"font-weight":"400","margin":"0px !important","padding":"0px !important"}},[_vm._v("\n    "+_vm._s(_vm.VALUE == "A" ? _vm.$t("Payee") : _vm.$t("Dept"))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }